import './ErrorScreen.scss';

import React from 'react';
import Button from 'src/component/UI/Button';
import { useTranslation } from 'src/i18n';

export default function ErrorScreen () {
  const { t } = useTranslation();

  const handleRefresh = () => {
    window.location.href='/';
  };
  return (
    <div className='error-screen'>
      <div className='error-screen-text'>
        <h1>{t('error.houston')}</h1>
        <p>{t('error.engineeringAware')}</p>
        <Button onClick={() => handleRefresh()} color="primary" variant="contained" fullWidth type="submit" cta>{t('error.returnHome')}</Button>
      </div>
    </div>
  );
}
